var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopyBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 542 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6665 5.16669C2.94265 5.16669 3.1665 5.39054 3.1665 5.66669V11C3.1665 12.1966 4.13655 13.1667 5.33317 13.1667H9.99984C10.276 13.1667 10.4998 13.3905 10.4998 13.6667C10.4998 13.9428 10.276 14.1667 9.99984 14.1667H5.33317C3.58427 14.1667 2.1665 12.7489 2.1665 11V5.66669C2.1665 5.39054 2.39036 5.16669 2.6665 5.16669Z",
    fill: "#222729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 543 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99984 3.16669C5.5396 3.16669 5.1665 3.53978 5.1665 4.00002V10.3334C5.1665 10.7936 5.5396 11.1667 5.99984 11.1667H12.3332C12.7934 11.1667 13.1665 10.7936 13.1665 10.3334V4.00002C13.1665 3.53978 12.7934 3.16669 12.3332 3.16669H5.99984ZM4.1665 4.00002C4.1665 2.9875 4.98732 2.16669 5.99984 2.16669H12.3332C13.3457 2.16669 14.1665 2.9875 14.1665 4.00002V10.3334C14.1665 11.3459 13.3457 12.1667 12.3332 12.1667H5.99984C4.98731 12.1667 4.1665 11.3459 4.1665 10.3334V4.00002Z",
    fill: "#222729"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyBlack);
export default __webpack_public_path__ + "static/media/icon-copy-black.960225cd7d3c68ac22003703f09e57c5.svg";
export { ForwardRef as ReactComponent };